"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineResponse20013 = void 0;
const iproduct_entity_1 = require("./iproduct-entity");
function parseInlineResponse20013(data) {
    if (data.records !== null && typeof data.records === 'object')
        data.records = data.records.map((x) => (0, iproduct_entity_1.parseIProductEntity)(x));
    return data;
}
exports.parseInlineResponse20013 = parseInlineResponse20013;
